import React from 'react';
import { useNavigate } from 'react-router-dom';
// import logoReto from "../images/elretodecarmen.png";
import logoPequeñoDeseo from "../images/deseo.jpeg"; 
import logoArena from "../images/arena.png"; 
import "../css/Colabora.css";
import RecaudacionHistorica from '../components/RecaudacionHistorica';

const Colabora = () => {
  const navigate = useNavigate();

  return (
   <main className="colabora-new-container fade-in-page">
      <div className="colabora-page-wrapper">
        
        {/* CABECERA CON TÍTULO Y ÁNIMO */}
        <header className="colabora-header-section">
          <h1 className="colabora-main-title">¿CÓMO PUEDES <span className="pink-text">AYUDAR?</span></h1>
          <div className="motivation-box">
            <p className="motivation-text">
              Tu apoyo es el combustible que nos hace avanzar. Cada donación se destina íntegramente a la 
              <strong> Fundación Pequeño Deseo</strong> para hacer realidad los sueños de niños con enfermedades graves.
            </p>
            <p className="cheer-text">
              ¡Anímate a colaborar! No importa la cantidad, sino el gesto de pedalear juntos por una sonrisa.
            </p>
          </div>
          <RecaudacionHistorica/>
        </header>

        <div className="colabora-options-column">
          
          {/* OPCIÓN 1: BIZUM */}
          <div className="colabora-card bizum-card">
            <div className="card-icon">📱</div>
            <div className="card-info">
              <h3>Dona con Bizum</h3>
              <div className="bizum-details">
                <span className="biz_label">CÓDIGO ONG:</span>
                <span className="biz_code">33605</span>
              </div>
              <p className="concept-highlight">Concepto: <strong>El Reto de Carmen</strong></p>
            </div>
          </div>

          {/* OPCIÓN 2: TRANSFERENCIA (CON LOGO DE FUNDACIÓN) */}
          <div className="colabora-card fpd-card">
            <div className="card-icon"><img src={logoPequeñoDeseo} alt="Fundación Pequeño Deseo" className="inline-fpd-logo" /></div>
            <div className="card-info">
              <div className="title-with-logo">
                <h3>Fundación Pequeño Deseo</h3>
              </div>
              <p>Transferencia directa la cuenta oficial de la <strong>Fundación Pequeño Deseo</strong></p>
              <p className="iban-display">ES27 2100 0835 1802 0104 4861</p>
              <span className="helper-tag">Indica en concepto  <strong>"El Reto de Carmen"</strong> al realizarla</span>
            </div>
          </div>

          {/* OPCIÓN 3: MI GRANO DE ARENA */}
          <div className="colabora-card">
            <div className="card-icon"><div className="card-icon"><img src={logoArena} alt="Mi grano de arena ORG" className="inline-fpd-logo" /></div></div>
            <div className="card-info">
              <h3>Mi Grano de Arena</h3>
              <p>Únete a nuestra campaña de crowdfunding solidario.</p>
              <button 
                className="btn-external"
                onClick={() => window.open('https://www.migranodearena.org/reto/el-reto-carmen-correoso-', '_blank')}
              >
                APORTAR MI GRANO DE ARENA
              </button>
            </div>
          </div>

          {/* OPCIÓN 4: CRM OFICIAL */}
          <div className="colabora-card">
            <div className="card-icon">📊</div>
            <div className="card-info">
              <h3>Aportaciones CRM Oficial</h3>
              <p>FUNDACIÓN PEQUEÑO DESEO</p>
              <button 
                className="btn-external primary-pink"
                onClick={() => window.open('https://crm.fpdeseo.org/civicrm/event/info?reset=1&id=24', '_blank')}
              >
                ACCEDER AL CRM
              </button>
            </div>
          </div>
          {/* NUEVA SECCIÓN: EMPRESAS Y CONTACTO DIRECTO */}
        <section className="colabora-business-cta">
          <div className="business-content">
            <div className="business-text">
              <span className="badge-business">EMPRESAS Y COLABORADORES</span>
              <h2>¿Quieres ir un paso más allá?</h2>
              <p>
                Si representas a una **empresa**, necesitas información sobre certificados de donación 
                o quieres proponer una colaboración especial, estamos deseando escucharte.
              </p>
            </div>
            <button className="btn-contact-direct" onClick={() => navigate('/contacto')}>
              CONTACTA CON NOSOTROS
            </button>
          </div>
        </section>

        </div>
      </div>
    </main>
  );
};

export default Colabora;